import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { ProductAdditionalProductCost } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductAdditionalProductCostService extends TmsWebBaseEditCreateService<
  ProductAdditionalProductCost,
  ProductAdditionalProductCost
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('ProductAdditionalProductCost', $localize`Product Additional Product Cost`);
  }

  getForProductSales(id: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForProductAdditionalProductCost/${id}`);
  }

  getAdditionalProductCostsForProduct(ProductId: string): Observable<ProductAdditionalProductCost[]> {
    return this.httpService.get<ProductAdditionalProductCost[]>(`${this.apiUrl}/Product/${ProductId}`);
  }

  getAllAdditionalProductCostsForProducts(ProductId: string): Observable<ProductAdditionalProductCost[]> {
    return this.httpService.get<ProductAdditionalProductCost[]>(
      `${this.apiUrl}/GetAllAdditionalProductCosts/${ProductId}`,
    );
  }

  updateAdditionalProductCostsProducts(ProductId: string, additionalProductCostIds: string[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateAdditionalProductCostsProducts`, {
      ProductId,
      additionalProductCostIds,
    });
  }
}
